import { FunctionComponent } from 'react'
import {
  FeedbackCardsContainer,
  ShimmerActiveFeedbackCard,
  ShimmerFeedbackCard,
  ShimmerProgressBar,
  ShimmerSuggestionTabButton,
  ShimmerSuggestionTabsWrapper,
} from './styled'

const TOTAL_CARDS_IN_SHIMMER = 6

interface ShimmerFeedbackCardsProps {
  hasOpenCard: boolean
  noOfCards: number
}

const ShimmerFeedbackCards: FunctionComponent<ShimmerFeedbackCardsProps> = ({
  hasOpenCard,
  noOfCards,
}) => {
  return (
    <FeedbackCardsContainer>
      {hasOpenCard && <ShimmerActiveFeedbackCard />}
      <ShimmerFeedbackCard line={noOfCards} />
    </FeedbackCardsContainer>
  )
}

const ShimmerSuggestionTabs = () => {
  return (
    <ShimmerSuggestionTabsWrapper>
      <ShimmerSuggestionTabButton />
      <ShimmerSuggestionTabButton />
    </ShimmerSuggestionTabsWrapper>
  )
}

export {
  ShimmerProgressBar,
  ShimmerFeedbackCards,
  ShimmerSuggestionTabs,
  TOTAL_CARDS_IN_SHIMMER,
}
